import { VoiceCommand } from "../command-registry";
import { VoiceIntent, ParsedIntent } from "../intent-parser";
import { PortalMessageToApp } from "../../providers/portal-provider";

export interface SearchCommandDependencies {
  sendMessageToApp: (message: PortalMessageToApp) => void;
}

const MIN_SEARCH_TERM_LENGTH = 2;

export function createSearchCommand(
  deps: SearchCommandDependencies
): VoiceCommand {
  return {
    intent: VoiceIntent.SEARCH,
    description: 'Busca serviços no portal. Ex: "buscar saúde"',

    validate: (parsed: ParsedIntent): boolean => {
      return parsed.value.trim().length >= MIN_SEARCH_TERM_LENGTH;
    },

    execute: (parsed: ParsedIntent): void => {
      deps.sendMessageToApp({
        detail: {
          pushRoute: `/search/${encodeURIComponent(parsed.value)}`,
        },
      });
    },
  };
}
